<template>
  <b-modal
    :id="`${serviceType}-trips-by-zone-modal`"
    title="Trips By Zones"
    size="lg"
    ok-only
    @show="getTripsStatsByZone"
  >
    <BSpinner
      v-if="loading"
      variant="primary"
    />
    <b-row
      v-else
    >
      <b-col
        v-for="(value, key) in statsData"
        :key="key"
        sm="12"
        md="6"
      >
        <tripsByZoneTable
          :caption="value.caption"
          :data="value"
        />
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import {
  BModal, BSpinner, BRow, BCol,
} from 'bootstrap-vue'
import { ref } from '@vue/composition-api'
import tripsByZoneTable from './TripsByZoneTable.vue'

export default {
  components: {
    BModal,
    BSpinner,
    BRow,
    BCol,
    tripsByZoneTable,
  },
  props: {
    serviceType: {
      type: String,
      default: undefined,
    },
  },
  setup(props, { root }) {
    const statsData = ref({})
    const loading = ref(false)
    const getTripsStatsByZone = async () => {
      loading.value = true
      const res = await root.$store.dispatch('trips/fetchTripsStatsByZone')
      statsData.value = {
        today: {
          caption: 'Today',
          ...res.stats.today,
        },
        yesterday: {
          caption: 'Yesterday',
          ...res.stats.yesterday,
        },
        yesterdayTillNow: {
          caption: 'Yesterday (*)',
          ...res.stats.yesterdayTillNow,
        },
        lastweek: {
          caption: 'Last Week',
          ...res.stats.lastweek,
        },
        lastweekTillNow: {
          caption: 'Last Week (*)',
          ...res.stats.lastweekTillNow,
        },
      }
      console.log(statsData.value)
      loading.value = false
    }
    return {
      getTripsStatsByZone,
      statsData,
      loading,
    }
  },
}
</script>

<style>

</style>
